import qrcode from 'qrcode';

const rotateCanvas90CW = (canvas) => {
    const rotCanvas = new OffscreenCanvas(canvas.height, canvas.width);
    const rotCtx = rotCanvas.getContext('2d');
    rotCtx.translate(rotCanvas.width / 2, rotCanvas.height / 2);
    rotCtx.rotate(Math.PI / 2);
    rotCtx.drawImage(canvas, -rotCanvas.height / 2, -rotCanvas.width / 2);
    return rotCanvas;
};


const WIDTH_OFFSET_RATIO = .35;
const HEIGHT_OFFSET_RATIO = 1;
const TEXT_SIZE_RATIO = .36;
const BOTTOM_TEXT_SIZE_RATIO = .275;
const TOP_TEXT_OFFSET = .25;
const MIDDLE_TEXT_OFFSET = 0.9;
const QRCODE_HEIGHT_OFFSET_DIVISOR = 1.5;
const QRCODE_WIDTH_OFFSET = .06;

class BadgeIDCenterQRCode {
    constructor(hasQrCode = true) {
        this.hasQrCode = hasQrCode;
    }

    setHasQrCode(value) {
        this.hasQrCode = value;
    }

    async generateLabel(QRText, MiddleText, BottomText, length, width, rotate) {
        return new Promise((resolve, reject) => {
            const QRWidth = length * WIDTH_OFFSET_RATIO * 1.2;
            const QRHeight = length * HEIGHT_OFFSET_RATIO * 1.5;
            const TopTextHeight = length * TOP_TEXT_OFFSET * 1.95;
            const MiddleTextHeight = length * MIDDLE_TEXT_OFFSET;

            const badgeTextScale = 0.15;
            var scaleValue = (badgeTextScale * QRText.length) + badgeTextScale;
            var textSizeScale = QRText.length / (QRText.length * scaleValue);
            var textSize = length * TEXT_SIZE_RATIO * textSizeScale;

            const bottomTextSize = length * BOTTOM_TEXT_SIZE_RATIO;
            const font = `bold ${textSize}px Courier New`;
            const bottomFont = `bold ${bottomTextSize}px Courier New`;

            var canvas = new OffscreenCanvas(width, length);
            const ctx = canvas.getContext('2d');

            ctx.save();
            ctx.scale(1.3, 1);
            ctx.font = font;
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = 'black';
            ctx.textAlign = "center";
            ctx.letterSpacing = "-25px";
            ctx.fillText(QRText, (length * 0.1) + 180, TopTextHeight + 40);
            ctx.restore();

            ctx.letterSpacing = "0px";
            ctx.font = bottomFont;
            ctx.fillText(MiddleText, (QRWidth * .1 + QRWidth) + 100, MiddleTextHeight);

            qrcode.toCanvas(new OffscreenCanvas(QRWidth, QRHeight), QRText, { errorCorrectionLevel: 'H', width: QRWidth, quality: 0, height: QRHeight , margin: 2 }, (err, qr) => {
                if (err) {
                    reject(err);
                }

                if (this.hasQrCode) {
                                      ctx.drawImage(qr, (canvas.width * QRCODE_WIDTH_OFFSET), MiddleTextHeight / QRCODE_HEIGHT_OFFSET_DIVISOR);
                }

                if (rotate) {
                    canvas = rotateCanvas90CW(canvas);
                }

                canvas.convertToBlob()
                    .then(blob => {
                        resolve(blob);
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        });
    }
}

export default BadgeIDCenterQRCode;